import { connect } from 'react-redux';
import { getTranslation } from "../../../reducers/common/localization";
import SecuritySettings from "./SecuritySettings";
import {
    fetchGetSecurity,
    clearSecurity,
    getSecurityLoading,
    is2FAEnable
} from '../../../reducers/account/security';
import { showModal, MODAL_CHANGE_2FA_ENABLING } from '../../../reducers/common/activeModal';

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        loading: getSecurityLoading(state),
        is2FAEnable: is2FAEnable(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => dispatch(fetchGetSecurity()),
        onUnmount: () => dispatch(clearSecurity()),
        onSubmit: () => dispatch(showModal({ modalKey: MODAL_CHANGE_2FA_ENABLING }))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SecuritySettings);



// WEBPACK FOOTER //
// ./src/components/accountManagement/securitySettings/SecuritySettings.container.js